module.exports = __webpack_public_path__ + "img/物联网示范项目公示.b710e7b4.png";